// src/pages/orders/components/bulk/ShopSelector.jsx
import React, { useEffect, useState } from 'react';
import { Store, ChevronDown, Lock } from 'lucide-react';
import { useLocalization } from '../../../../contexts/LocalizationContext';
import { getShops } from '../../../../services/api/shops';
import styles from './ShopSelector.module.css';

const ShopSelector = ({ selectedShop, onShopChange, disabled }) => {
  const { t } = useLocalization();
  const [shops, setShops] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadShops = async () => {
      try {
        const response = await getShops({assigned:true, type:'online,dropshipper'});
        setShops(response || []);
        
        // Auto-select if only one shop
        if (response && response.length === 1 && !selectedShop) {
          onShopChange(response[0]);
        }
      } catch (error) {
        console.error('Failed to load shops:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    loadShops();
  }, []);

  if (isLoading) {
    return (
      <div className={styles.shopSelector}>
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
          <span>Loading shops...</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.shopSelector}>
      <div className={styles.sectionHeader}>
        <Store size={20} />
        <h3>{t('ecomOrders.selectShop')}</h3>
        {disabled && <Lock size={16} className={styles.lockIcon} />}
      </div>

      <div className={styles.selectWrapper}>
        <Store className={styles.selectIcon} size={18} />
        <select
          value={selectedShop?.id || ''}
          onChange={(e) => {
            const shop = shops.find(s => s.id === parseInt(e.target.value));
            if (shop) onShopChange(shop);
          }}
          disabled={disabled}
          className={styles.select}
        >
          <option value="">{t('ecomOrders.selectShop')}</option>
          {shops.map(shop => (
            <option key={shop.id} value={shop.id}>
              {shop.name} ({shop.type})
            </option>
          ))}
        </select>
        <ChevronDown className={styles.selectArrow} size={18} />
      </div>

      {selectedShop && (
        <div className={styles.selectedShopInfo}>
          <div className={styles.shopName}>{selectedShop.name}</div>
          <div className={styles.shopType}>{selectedShop.type}</div>
        </div>
      )}

      {disabled && (
        <div className={styles.disabledNote}>
          Shop cannot be changed after uploading file
        </div>
      )}
    </div>
  );
};

export default ShopSelector;